(function () {
  'use strict';

  angular.module('clientDashboardApp.httpUtil.getRequestInterceptor',['clientDashboardApp.httpUtil.getRequestService']
  ).factory("getRequestInterceptor", GetRequestInterceptor);

  GetRequestInterceptor.$inject = ['$q','getRequestService', 'browserService'];

  function isHTMLFile(url){
    return url.indexOf('.html') > -1;
  }

  function appendRandomQueryString(url){
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url+separator+'noCache=' + new Date().getTime();
  }

  function GetRequestInterceptor($q,getRequestService, browserService){
    return {
      request: function(config){
        if(config.method=="GET"){
          var timestamp = new Date().getTime();
          config.requestTimestamp = timestamp;
          if(browserService.isMSIE() && !isHTMLFile(config.url)){
            config.url = appendRandomQueryString(config.url);
          }
          getRequestService.registerRequest(config.url,timestamp);
        }
        return config;
      },
      response: function(response){
        if(response.config.method=="GET"){
          if(response.config.cache || getRequestService.isMostRecentRequest(response.config.url,response.config.requestTimestamp) || isHTMLFile(response.config.url)){
            return response;
          }
          else{
            console.log('rejecting response from older duplicate request:', response);
            // TODO - just return the promise for the more recent request
            // and remove workaround in LocationService.locationsAndGroups
            return $q.reject(response);
          }
        }
        return response;
      }

    };
  }

})();

